import {DesignedHeader} from '../../commonComponents/DesignedHeader';
import {HorizontalDivider} from '../../commonComponents/HorizontalDivider';
import ContactUsForm from '../ContactUsComponent/ContactUsForm';

import {AboutUs} from './AboutUs';

const AboutUsScreen = () => {
  return (
    <div
      className={`w-full
        bg-[#faf8f5]
        px-4
        sm:px-6
        lg:px-12
        xl:px-20
        py-6
        lg:py-10`}
      
    >
      <div
        className=
          {` max-w-7xl
          mx-auto
          flex
          flex-col
          gap-8
          sm:gap-10
          lg:gap-14`}
        
      >
        {/* heading */}
        <div className={'text-center'}>
          <h1
            className=
              {`italianno-regular
              text-primary-900
              text-4xl
              sm:text-5xl
              md:text-6xl
              lg:text-7xl`}
            
            data-aos={'fade-up'}
          >
            <DesignedHeader title={'About Ratnaparkhi'} />
          </h1>
        </div>

        {/* about content */}
        <div>
          <AboutUs />
        </div>

        {/* divider */}
        <div className={'py-2 sm:py-4'}>
          <HorizontalDivider />
        </div>

        {/* contact form */}
        <div
          className=
            {`w-full
            max-w-4xl
            mx-auto`}
          
          data-aos={'fade-up'}
        >
          <ContactUsForm />
        </div>
      </div>
    </div>
  );
};

export default AboutUsScreen;
